import { FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { DefaultRoutes, useClientPageVisibility } from '@cbridge-packages/routing-client-admin';

/**
 * /config/profiles lands on Routing profiles, which are hidden without the basicBridge feature:
 * fall back to Pricing profiles then.
 */
export const ProfilesIndexRedirect: FunctionComponent = () => {
  const { isTradingVisible } = useClientPageVisibility();

  return <Navigate to={isTradingVisible ? DefaultRoutes.ConfigProfiles : DefaultRoutes.ConfigProfilesPricing} replace={true} />;
};
